import Swiper, { Navigation, Pagination } from 'swiper';

class TestimonialSlider {
  constructor(el) {
    this.el = el;
    Swiper.use([Navigation, Pagination]);

    this.initSlider();
  }

  initSlider() {
    new Swiper(this.el.querySelector('.swiper'), {
      speed: 400,
      spaceBetween: 0,
      centeredSlides: true,
      slidesPerView: 1,
      loop: true,
      loopAdditionalSlides: 5,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
}

export default TestimonialSlider;
